import { attribute, autoGeneratedHashKey } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { dynamicTableName } from '@pristine-ts/aws';
import { InviteStatusEnum } from '../enums/invite-status.enum';
import { EmployeeRoleEnum } from '../enums/employee-role.enum';
import { property } from '@pristine-ts/metadata';

@dynamicTableName('INVITE_TABLE_NAME')
export class InviteModel {
  @autoGeneratedHashKey()
  @property()
  id: string;
  @attribute()
  @property()
  organizationId: string;
  @attribute()
  @property()
  organizationName: string;
  @attribute()
  @property()
  email: string;
  @attribute()
  @property()
  status: InviteStatusEnum;
  @attribute()
  @property()
  role: EmployeeRoleEnum;
  @attribute()
  @property()
  userId: string;
  @attribute()
  @property()
  createdAt: Date;
  @attribute()
  @property()
  updatedAt: Date;
}
